module.exports = __webpack_public_path__ + "static/media/prison_break_cover.03d49c38.jpg";